import type { ShopItem } from "@/types/shop";

export enum ClassicSkin {
	SKIN_01 = "skin_01",
	SKIN_02 = "skin_02",
	SKIN_03 = "skin_03",
	SKIN_04 = "skin_04",
	SKIN_05 = "skin_05",
	SKIN_06 = "skin_06",
	SKIN_07 = "skin_07",
	SKIN_08 = "skin_08",
	SKIN_RESOURCE_01 = "skin_resource_01",
	SKIN_RESOURCE_02 = "skin_resource_02",
	SKIN_STORAGE_01 = "skin_storage_01",
	SKIN_STORAGE_02 = "skin_storage_02",
	SKIN_EXPLORATION_01 = "skin_exploration_01",
	SKIN_EXPLORATION_02 = "skin_exploration_02",
	SKIN_PEOPLE_01 = "skin_people_01",
	SKIN_PEOPLE_02 = "skin_people_02",
	SKIN_FOOD_01 = "skin_food_01",
	SKIN_FOOD_02 = "skin_food_02",
	SKIN_COIN_01 = "skin_coin_01",
	SKIN_COIN_02 = "skin_coin_02",
	SKIN_BUILDING_01 = "skin_building_01",
	SKIN_BUILDING_02 = "skin_building_02",
	SKIN_LEVEL_UP_01 = "skin_level_up_01",
	SKIN_LEVEL_UP_02 = "skin_level_up_02",
	SKIN_GEM_01 = "skin_gem_01",
	SKIN_GEM_02 = "skin_gem_02",
	SKIN_GEM_03 = "skin_gem_03",
	SKIN_GEM_04 = "skin_gem_04",
}

export enum EventPassSkin {
	EVENT_PASS_SKIN_EASTER_01 = "event_pass_skin_easter_01",
	EVENT_PASS_SKIN_FISHING_01 = "event_pass_skin_fishing_01",
	EVENT_PASS_SKIN_FIREFEST_01 = "event_pass_skin_firefest_01",
	EVENT_PASS_SKIN_HUNTING_01 = "event_pass_skin_hunting_01",
	EVENT_PASS_SKIN_HALLOWEEN_01 = "event_pass_skin_halloween_01",
}

export enum EventSkin {
	// Easter skins
	EVENT_SKIN_EASTER_01 = "event_skin_easter_01",
	EVENT_SKIN_EASTER_02 = "event_skin_easter_02",
	EVENT_SKIN_EASTER_03 = "event_skin_easter_03",
	EVENT_SKIN_EASTER_04 = "event_skin_easter_04",
	EVENT_SKIN_EASTER_05 = "event_skin_easter_05",
	EVENT_SKIN_EASTER_06 = "event_skin_easter_06",
	EVENT_SKIN_EASTER_07 = "event_skin_easter_07",
	EVENT_SKIN_EASTER_08 = "event_skin_easter_08",
	EVENT_SKIN_EASTER_09 = "event_skin_easter_09",
	EVENT_SKIN_EASTER_10 = "event_skin_easter_10",
	EVENT_SKIN_EASTER_11 = "event_skin_easter_11",
	EVENT_SKIN_EASTER_12 = "event_skin_easter_12",

	// Fishing skins
	EVENT_SKIN_FISHING_01 = "event_skin_fishing_01",
	EVENT_SKIN_FISHING_02 = "event_skin_fishing_02",
	EVENT_SKIN_FISHING_03 = "event_skin_fishing_03",
	EVENT_SKIN_FISHING_04 = "event_skin_fishing_04",
	EVENT_SKIN_FISHING_05 = "event_skin_fishing_05",
	EVENT_SKIN_FISHING_06 = "event_skin_fishing_06",
	EVENT_SKIN_FISHING_07 = "event_skin_fishing_07",
	EVENT_SKIN_FISHING_08 = "event_skin_fishing_08",

	// Firefest skins
	EVENT_SKIN_FIREFEST_01 = "event_skin_firefest_01",
	EVENT_SKIN_FIREFEST_02 = "event_skin_firefest_02",
	EVENT_SKIN_FIREFEST_03 = "event_skin_firefest_03",
	EVENT_SKIN_FIREFEST_04 = "event_skin_firefest_04",
	EVENT_SKIN_FIREFEST_05 = "event_skin_firefest_05",
	EVENT_SKIN_FIREFEST_06 = "event_skin_firefest_06",
	EVENT_SKIN_FIREFEST_07 = "event_skin_firefest_07",
	EVENT_SKIN_FIREFEST_08 = "event_skin_firefest_08",
	EVENT_SKIN_FIREFEST_09 = "event_skin_firefest_09",
	EVENT_SKIN_FIREFEST_10 = "event_skin_firefest_10",
	EVENT_SKIN_FIREFEST_11 = "event_skin_firefest_11",
	EVENT_SKIN_FIREFEST_12 = "event_skin_firefest_12",

	// Solarfair skins
	EVENT_SKIN_SOLARFAIR_01 = "event_skin_solarfair_01",
	EVENT_SKIN_SOLARFAIR_02 = "event_skin_solarfair_02",
	EVENT_SKIN_SOLARFAIR_03 = "event_skin_solarfair_03",
	EVENT_SKIN_SOLARFAIR_04 = "event_skin_solarfair_04",
	EVENT_SKIN_SOLARFAIR_05 = "event_skin_solarfair_05",
	EVENT_SKIN_SOLARFAIR_06 = "event_skin_solarfair_06",
	EVENT_SKIN_SOLARFAIR_07 = "event_skin_solarfair_07",
	EVENT_SKIN_SOLARFAIR_08 = "event_skin_solarfair_08",
	EVENT_SKIN_SOLARFAIR_09 = "event_skin_solarfair_09",
	EVENT_SKIN_SOLARFAIR_10 = "event_skin_solarfair_10",
	EVENT_SKIN_SOLARFAIR_11 = "event_skin_solarfair_11",
	EVENT_SKIN_SOLARFAIR_12 = "event_skin_solarfair_12",

	//Hunting skins
	EVENT_SKIN_HUNTING_01 = "event_skin_hunting_01",
	EVENT_SKIN_HUNTING_02 = "event_skin_hunting_02",
	EVENT_SKIN_HUNTING_03 = "event_skin_hunting_03",
	EVENT_SKIN_HUNTING_04 = "event_skin_hunting_04",
	EVENT_SKIN_HUNTING_05 = "event_skin_hunting_05",
	EVENT_SKIN_HUNTING_06 = "event_skin_hunting_06",
	EVENT_SKIN_HUNTING_07 = "event_skin_hunting_07",
	EVENT_SKIN_HUNTING_08 = "event_skin_hunting_08",
	EVENT_SKIN_HUNTING_09 = "event_skin_hunting_09",
	EVENT_SKIN_HUNTING_10 = "event_skin_hunting_10",
	EVENT_SKIN_HUNTING_11 = "event_skin_hunting_11",
	EVENT_SKIN_HUNTING_12 = "event_skin_hunting_12",

	//Halloween skins
	EVENT_SKIN_HALLOWEEN_01 = "event_skin_halloween_01",
	EVENT_SKIN_HALLOWEEN_02 = "event_skin_halloween_02",
	EVENT_SKIN_HALLOWEEN_03 = "event_skin_halloween_03",
	EVENT_SKIN_HALLOWEEN_04 = "event_skin_halloween_04",
	EVENT_SKIN_HALLOWEEN_05 = "event_skin_halloween_05",
	EVENT_SKIN_HALLOWEEN_06 = "event_skin_halloween_06",
	EVENT_SKIN_HALLOWEEN_07 = "event_skin_halloween_07",
	EVENT_SKIN_HALLOWEEN_08 = "event_skin_halloween_08",
	EVENT_SKIN_HALLOWEEN_09 = "event_skin_halloween_09",
	EVENT_SKIN_HALLOWEEN_10 = "event_skin_halloween_10",
	EVENT_SKIN_HALLOWEEN_11 = "event_skin_halloween_11",
	EVENT_SKIN_HALLOWEEN_12 = "event_skin_halloween_12",

	// Pirate's treasure skins
	EVENT_SKIN_PIRATES_01 = "event_skin_pirates_01",
	EVENT_SKIN_PIRATES_02 = "event_skin_pirates_02",
	EVENT_SKIN_PIRATES_03 = "event_skin_pirates_03",
	EVENT_SKIN_PIRATES_04 = "event_skin_pirates_04",
	EVENT_SKIN_PIRATES_05 = "event_skin_pirates_05",
	EVENT_SKIN_PIRATES_06 = "event_skin_pirates_06",
	EVENT_SKIN_PIRATES_07 = "event_skin_pirates_07",
	EVENT_SKIN_PIRATES_08 = "event_skin_pirates_08",
	EVENT_SKIN_PIRATES_09 = "event_skin_pirates_09",
	EVENT_SKIN_PIRATES_10 = "event_skin_pirates_10",
	EVENT_SKIN_PIRATES_11 = "event_skin_pirates_11",
	EVENT_SKIN_PIRATES_12 = "event_skin_pirates_12",
}

export enum RegularStarterSkin {
	V1 = "regular_starter_skin_01", // skin_01
	V2 = "regular_starter_skin_02", // skin_02
	V3 = "regular_starter_skin_03", // skin_03
	V4 = "regular_starter_skin_04", // skin_04
	V5 = "regular_starter_skin_05", // skin_05
	V6 = "regular_starter_skin_06", // skin_06
	V7 = "regular_starter_skin_07", // skin_07
	V8 = "regular_starter_skin_08", // skin_08
	GOLDEN = "regular_starter_skin_golden",
}

export enum RegularGemSkin {
	V1 = "regular_gem_skin_01",
	V2 = "regular_gem_skin_02",
	V3 = "regular_gem_skin_03",
	V4 = "regular_gem_skin_04",
}

export enum PiggyBankSkin {
	GEM_SKIN_01 = "piggy_bank_gem_skin_01",
}

export enum ProvisionSkin {
	ROYAL_SKIN_01 = "provision_royal_skin_01",
}

export const allowedSkins = [
	...Object.values(ClassicSkin),
	...Object.values(EventPassSkin),
	...Object.values(EventSkin),
	...Object.values(RegularStarterSkin),
	...Object.values(RegularGemSkin),
	...Object.values(PiggyBankSkin),
	...Object.values(ProvisionSkin),
] as const;

/**
 * Extracts a union type from the array's numeric indices.
 * Using '[number]' looks at all values in the array to create the type.
 */
export type AllowedSkin = (typeof allowedSkins)[number];

// Helper for useShopStore
export const filterBySkinPrefix = (
	items: ShopItem[] | null,
	includePrefix: string,
	excludeKeys: string[] = [],
): ShopItem[] | null => {
	const filtered = items?.filter((item: ShopItem): boolean => {
		const skinValue = item.attributes?.skin;

		// If the skin attribute is missing, exclude it from the result
		if (!skinValue) return false;

		// Exclude items if they contain any of the excluded keys (case-sensitive)
		const isExcluded = excludeKeys.some((key: string): boolean =>
			skinValue.includes(key),
		);
		if (isExcluded) return false;

		// Keep only if it starts with the specified prefix
		return skinValue.startsWith(includePrefix);
	});

	return filtered?.length ? filtered : null;
};
